module.exports = __webpack_public_path__ + "static/img/企业使命.7a85743.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/企业使命.png
// module id = hXMm
// module chunks = 13